import { useContext } from 'react';
import { ComponentSectionContext } from '../../context/ComponentSectionContext';

export const useComponentSectionContext = () => {
  const context = useContext(ComponentSectionContext);

  if (context.isProvided === false) {
    throw new Error(
      'useComponentSectionContext must be used within a ComponentSectionContextProvider'
    );
  }

  return context;
};
